import { AiOutlineInsertRowRight } from "@react-icons/all-files/ai/AiOutlineInsertRowRight";
import Myntraproject from "../../../images/myntra-project.png";
import portfolioproject from "../../../images/portfolio-personal.png";
import spotifyproject from "../../../images/spotify-clone.png";

import "./Portfolio.css";
const Portfolio = () => {
  return (
    <div className="pages-page-main">
      <div className="pages-inner-content">
        <div
          className="pages-heading-div"
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
        >
          <AiOutlineInsertRowRight className="pages-page-icon" />
          <span className="pages-introduce">Portfolio</span>
        </div>
        <div
          data-aos="fade-up"
          data-aos-offset="0"
          data-aos-delay="0"
          data-aos-duration="1200"
          data-aos-easing="ease-out"
          className="about-introduction-heading"
        >
          Featured <span className="colored-heading">Projects</span>
        </div>
        <div className="projects-main-div">
          <div
            className="single-project-div"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="project-image-div">
              <a
                href="https://suryansh-spotify-clone.vercel.app"
                target="_blank"
              >
                <img className="project-image" src={spotifyproject}></img>
              </a>
              <div className="project-description-div">
                <div className="project-stack-used-name">React</div>
                <div className="project-stack-used-name">Nodejs</div>
                <div className="project-stack-used-name">Mongodb</div>
              </div>
            </div>
            <a
              href="https://suryansh-spotify-clone.vercel.app"
              target="_blank"
              className="project-name-link"
            >
              spotify clone
            </a>
          </div>
<div
            className="single-project-div"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="project-image-div">
              <a
                href="https://suryansh-myntra-clone.vercel.app"
                target="_blank"
              >
                <img className="project-image" src={Myntraproject}></img>
              </a>
              <div className="project-description-div">
                <div className="project-stack-used-name">React</div>
                <div className="project-stack-used-name">Nodejs</div>
                <div className="project-stack-used-name">Mongodb</div>
              </div>
            </div>
            <a
              href="https://suryansh-myntra-clone.vercel.app"
              target="_blank"
              className="project-name-link"
            >
              Myntra - clone
            </a>
</div>
          <div
            className="single-project-div"
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-duration="1200"
            data-aos-easing="ease-out"
          >
            <div className="project-image-div">
              <img className="project-image" src={portfolioproject}></img>
              <div className="project-description-div">
                <div className="project-stack-used-name">React</div>
              </div>
            </div>
            <div className="project-name-link">personal portfolio</div>
          </div>
          
          
        </div>
      </div>
    </div>
  );
};
export default Portfolio;
